// Campus photo for /colleges/michigan-technological-university: CC BY-SA 4.0, by Jcvertin, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMichigan_Tech_campus%2C_fall_2018..jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/michigan-technological-university/; credited under the photo.
const photo = {
    "slug": "michigan-technological-university",
    "alt": "Michigan Tech campus in autumn color above the Portage Canal in Houghton, Michigan",
    "src": "/colleges/michigan-technological-university/campus-1600.webp",
    "srcSmall": "/colleges/michigan-technological-university/campus-800.webp",
    "srcMid": "/colleges/michigan-technological-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/michigan-technological-university/og.jpg",
    "title": "Michigan Tech campus, fall 2018.",
    "author": "Jcvertin",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMichigan_Tech_campus%2C_fall_2018..jpg",
    "read": "2026-10-02"
};

export default photo;
